<div class="container-fluid">
    <div class="row">

        <mat-label>
            {{tab.msg}}
        </mat-label>
    </div>


    <div class="row" style="margin-top:30px">
        <div class="col-lg-6">
            <button class="btn-secondary-light" mat-raised-button (click)="annuler()">ANNULER</button>
        </div>
        <div class="col-lg-6 text-end">
            <a class="btn-secondary" mat-raised-button (click)="supprimme()">CONFIRMER</a>
        </div>
    </div>

</div>